export const types = {
	INIT_DOCUMENTS: "INIT_FORM16_DOCUMENTS",
	ADD_DOCUMENT: "ADD_FORM16_DOCUMENT",
	REMOVE_DOCUMENT: "REMOVE_FORM16_DOCUMENT",
	RESET_DOCUMENTS: "RESET_FORM16_DOCUMENTS",
}

export const initForm16Docs = (documents) => {
	return (dispatch) => dispatch({
		type: types.INIT_DOCUMENTS,
		payload: documents
	})
}

export const addForm16Doc = (docData) => {
	return (dispatch) => dispatch({
		type: types.ADD_DOCUMENT,
		payload: docData
	})
}

export const removeForm16Doc = (docId) => {
	return (dispatch) => dispatch({
		type: types.REMOVE_DOCUMENT,
		payload: docId
	})
}

export const resetForm16Docs = () => {
	return (dispatch) => dispatch({
		type: types.RESET_DOCUMENTS,
	})
}
